var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3C(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 405 200",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "100,100 73.2050807568877,200 0,200 1.4210854715202E-14,126.794919243112",
    stroke: "black",
    strokeWidth: 4,
    fill: "#000000"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "100,100 1.4210854715202E-14,126.794919243112 0,73.2050807568878",
    stroke: "black",
    strokeWidth: 4,
    fill: "lightgrey"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "100,100 0,73.2050807568878 -1.4210854715202E-14,0 73.2050807568877,1.4210854715202E-14",
    stroke: "black",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "100,100 73.2050807568877,1.4210854715202E-14 126.794919243112,0",
    stroke: "black",
    strokeWidth: 4,
    fill: "lightgrey"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "100,100 126.794919243112,0 200,-5.6843418860808E-14 200,73.2050807568877",
    stroke: "black",
    strokeWidth: 4,
    fill: "#000000"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "100,100 200,73.2050807568877 200,126.794919243112",
    stroke: "black",
    strokeWidth: 4,
    fill: "lightgrey"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "100,100 200,126.794919243112 200,200 126.794919243112,200",
    stroke: "black",
    strokeWidth: 4,
    fill: "#000000"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "100,100 126.794919243112,200 73.2050807568877,200",
    stroke: "black",
    strokeWidth: 4,
    fill: "lightgrey"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "305,100 331.794919243112,1.4210854715202E-14 278.205080756888,0",
    stroke: "black",
    strokeWidth: 4,
    fill: "lightgrey"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "305,100 278.205080756888,0 205,-5.6843418860808E-14 205,73.2050807568877",
    stroke: "black",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "305,100 205,73.2050807568877 205,126.794919243112",
    stroke: "black",
    strokeWidth: 4,
    fill: "lightgrey"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "305,100 205,126.794919243112 205,200 278.205080756888,200",
    stroke: "black",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "305,100 278.205080756888,200 331.794919243112,200",
    stroke: "black",
    strokeWidth: 4,
    fill: "lightgrey"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "305,100 331.794919243112,200 405,200 405,126.794919243112",
    stroke: "black",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "305,100 405,126.794919243112 405,73.2050807568878",
    stroke: "black",
    strokeWidth: 4,
    fill: "lightgrey"
  }), "\"\n\n", /*#__PURE__*/React.createElement("polygon", {
    points: "305,100 405,73.2050807568878 405,0 331.794919243112,1.4210854715202E-14",
    stroke: "black",
    strokeWidth: 4,
    fill: "#000000"
  }), "\"\n\n\t")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3C);
export default __webpack_public_path__ + "static/media/3c.cb80bde8a9582d11aa33b4bb9038679c.svg";
export { ForwardRef as ReactComponent };